import React from 'react';
import { createContext } from 'react';
import { AuthTokenType } from 'src/graphql/__generated__/globalTypes';
import { IAuthUser } from 'src/services/AuthService/IAuthService';
import { noop } from 'src/utils/utils';

export const AuthContext = createContext<{
  user: IAuthUser | undefined;
  onLogin: (user: IAuthUser) => void;
  logout: () => void;
  setForcedScreen(screen: ForcedScreen | undefined): void;
}>({
  user: undefined,
  onLogin: noop,
  logout: noop,
  setForcedScreen: noop,
});

export function useAuthContext() {
  return React.useContext(AuthContext);
}

export type ForcedScreen = AuthTokenType.SHOP;
